import { gql } from '@apollo/client';

export const CheckPaymentsDebtMutation = gql`
  mutation CheckPaymentsDebt($agreements: [String]!) {
    checkStudentDebt(agreementsInput: $agreements) {
      customErrors {
        code
        field
        message
      }
      success
    }
  }
`;
